const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

const getLeadLogPageApi = async (id, resource, page, perPage, filters = {}) => {
    const token = localStorage.getItem('token');
    const params = new URLSearchParams({
        page: String(page),
        per_page: String(perPage),
    });

    if (filters.date_from) params.set('date_from', filters.date_from);
    if (filters.date_to) params.set('date_to', filters.date_to);

    ['categories', 'actor_types', 'actions'].forEach((key) => {
        (filters[key] || []).forEach((value) => params.append(`${key}[]`, value));
    });

    if (!token) {
        // throw new Error('Токен авторизации не найден.');
    }

    try {
        const response = await fetch(
            `${API_BASE_URL}/admin/lead/leads/${id}/${resource}?${params.toString()}`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            const requestError = new Error(errorData?.message || `Request failed with status ${response.status}`);
            Object.assign(requestError, errorData, { statusCode: response.status });
            throw requestError;
        }

        const result = await response.json();
        return {
            data: result.data || [],
            meta: {
                total_count: result.meta?.total || 0,
                current_page: result.meta?.current_page || page,
                per_page: result.meta?.per_page || perPage,
                total_pages: result.meta?.last_page || 1
            }
        };
    } catch (error) {
        console.error(`[getLeadLogPageApi] Ошибка получения ${resource} лида с ID ${id}:`, error);
        throw error;
    }
};

export const getLeadLogsApi = async (id, page = 1, perPage = 10, filters = {}) => (
    getLeadLogPageApi(id, 'logs', page, perPage, filters)
);

export const getLeadActivitiesApi = async (id, page = 1, perPage = 10, filters = {}) => (
    getLeadLogPageApi(id, 'activities', page, perPage, filters)
);
